import Breadcrumb from 'components/breadcrumb/Breadcrumb';
import { BreadcrumbItem } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BreadcrumbsWrapper } from './Breadcrumbs.styles';

const Breadcrumbs = ({
  name,
  logo,
  isChannelManager,
}: {
  name: string;
  logo: string;
  isChannelManager: boolean;
}) => {
  const { t } = useTranslation();

  const breadcrumbHref = isChannelManager
    ? '#/channels/channel-managers'
    : '#/channels/direct-channels';

  const breadcrumbText = isChannelManager
    ? t('pageChannels.channelDetails.breadcrumb.channelManagers')
    : t('pageChannels.channelDetails.breadcrumb.channels');

  return (
    <BreadcrumbsWrapper>
      <Breadcrumb>
        <BreadcrumbItem href={breadcrumbHref}>{breadcrumbText}</BreadcrumbItem>

        <BreadcrumbItem active>
          <img src={logo} alt="logo" />

          {name}
        </BreadcrumbItem>
      </Breadcrumb>
    </BreadcrumbsWrapper>
  );
};

export default Breadcrumbs;
